import { api } from "../utils/axios";
import { normalizeRestaurantPayload } from "../utils/restaurantPayload";

const getPlatform = (): string => {
  const ua = navigator.userAgent || navigator.vendor;

  // Detect iOS
  if (/iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream) {
    return 'iOS';
  }

  // Detect Android
  if (/android/i.test(ua)) {
    return 'Android';
  }

  // Default to web
  return 'web';
};

export const getFeed = async (lat?: number | null, lng?: number | null, recentRestaurantIds?: string[]) => {
  try {
    const params = new URLSearchParams();
    if (lat != null && lng != null) {
      params.append('lat', lat.toString());
      params.append('lng', lng.toString());
    }

    const response = await api.post(`/api/feed?${params.toString()}`, { recentRestaurantIds }, { withCredentials: true });
    return normalizeRestaurantPayload(response.data.data);
  } catch (error) {
    throw error;
  }
};
export const getExploreAreas = async (lat?: number | null, lng?: number | null) => {
  try {
    const params = new URLSearchParams();
    if (lat != null && lng != null) {
      params.append('lat', lat.toString());
      params.append('lng', lng.toString());
    }

    const response = await api.get(`/api/feed/explore-areas?${params.toString()}`, { withCredentials: true });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
export const getGemioRanks = async (lat?: number | null, lng?: number | null) => {
  try {
    const params = new URLSearchParams();
    if (lat != null && lng != null) {
      params.append('lat', lat.toString());
      params.append('lng', lng.toString());
    }

    const response = await api.get(`/api/feed/gemio-ranks?${params.toString()}`, { withCredentials: true });
    return normalizeRestaurantPayload(response.data.data);
  } catch (error) {
    throw error;
  }
};
export const getYouMayLike = async (lat?: number | null, lng?: number | null) => {
  try {
    const params = new URLSearchParams();
    if (lat != null && lng != null) {
      params.append('lat', lat.toString());
      params.append('lng', lng.toString());
    }

    const response = await api.get(`/api/feed/you-may-like?${params.toString()}`, { withCredentials: true });
    return normalizeRestaurantPayload(response.data.data);
  } catch (error) {
    throw error;
  }
};
export const getRecents = async (lat?: number | null, lng?: number | null, recentRestaurantIds?: string[]) => {
  try {
    const params = new URLSearchParams();
    if (lat != null && lng != null) {
      params.append('lat', lat.toString());
      params.append('lng', lng.toString());
    }

    const response = await api.post(`/api/feed/recently-viewed?${params.toString()}`, { recentRestaurantIds }, { withCredentials: true });
    return normalizeRestaurantPayload(response.data.data);
  } catch (error) {
    throw error;
  }
};
export const getCozySpots = async (lat?: number | null, lng?: number | null) => {
  try {
    const params = new URLSearchParams();
    if (lat != null && lng != null) {
      params.append('lat', lat.toString());
      params.append('lng', lng.toString());
    }

    const response = await api.get(`/api/feed/cozy-spots?${params.toString()}`, { withCredentials: true });
    return normalizeRestaurantPayload(response.data.data);
  } catch (error) {
    throw error;
  }
};
export const getLocalAreas = async (lat?: number | null, lng?: number | null ) => {
  try {
    const params = new URLSearchParams();
    if (lat != null && lng != null) {
      params.append('lat', lat.toString());
      params.append('lng', lng.toString());
    }

    const response = await api.get(`/api/feed/local-areas?${params.toString()}`, { withCredentials: true });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};


export const getAreaFeed = async (areaName: string, lat: number, lng: number) => {
    try {
        const response = await api.get(
        `/api/feed/areas/${encodeURIComponent(areaName)}?lat=${lat}&lng=${lng}`,
        { withCredentials: true }
        );
        return normalizeRestaurantPayload(response.data);
    } catch (error) {
        throw error;
    }
};

export const getAreaPhotos = async (areaName: string, limit=16, page: number) => {
    try {
        const response = await api.get(
        `/api/feed/areas/${encodeURIComponent(areaName)}/photos?page=${page}&limit=${limit}`,
        { withCredentials: true }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getTopRestaurants = async (areaName: string, filters: Record<string, any>, page: number, limit=16) => {
    try {
        const params = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            ...Object.entries(filters).reduce((acc, [key, value]) => {
                if (value !== undefined) acc[key] = String(value);
                return acc;
            }, {} as Record<string, string>)
        });

        const response = await api.get(
        `/api/restaurants/cities/${encodeURIComponent(areaName)}/top?${params.toString()}`,
        { withCredentials: true }
        );

        return normalizeRestaurantPayload(response.data.data);
    } catch (error) {
        throw error;
    }
};
export const getAreaRestaurants = async (areaName: string, filters: Record<string, any>, page: number, limit=16) => {
    try {
        const params = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            ...Object.entries(filters).reduce((acc, [key, value]) => {
                if (value !== undefined) acc[key] = String(value);
                return acc;
            }, {} as Record<string, string>)
        });

        const response = await api.get(
        `/api/restaurants/area/${encodeURIComponent(areaName)}?${params.toString()}`,
        { withCredentials: true }
        );

        return normalizeRestaurantPayload(response.data.data);
    } catch (error) {
        throw error;
    }
};

export const trackView = async (restaurantId: string) => {
    const platform = getPlatform() || "web";
  try {
    const response = await api.post(
      '/api/recent/track',
      { restaurantId, platform },
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    console.error(error)
    throw error;
  }
};

export const syncActivities = async (restaurantIds: string[]) => {
    const platform = getPlatform() || "web";

  try {
    const response = await api.post(
      '/api/recent/sync',
      { restaurantIds, platform },
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getRecentlyViewed = async (limit: number = 10) => {
  try {
    const response = await api.get(`/api/recent?limit=${limit}`, { withCredentials: true });
    return response.data;
  } catch (error) {
    throw error;
  }
};